 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"matchInfo":"matchInfo","groupstageList":"groupstageList","matchFeed":"matchFeed","playOff":"playOff","tournamentBrackets":"tournamentBrackets","tournamentInfo":"tournamentInfo","tournamentMatches":"tournamentMatches","tournamentNews":"tournamentNews","tournamentPage":"tournamentPage","tournamentRules":"tournamentRules","tournamentStatistics":"tournamentStatistics","tournamentTeams":"tournamentTeams","tournamentVideos":"tournamentVideos","tournamentWinners":"tournamentWinners"}[chunkId]||chunkId) + "." + {"chunk-0765dc10":"974c3814","chunk-116fcee8":"3702be1e","chunk-13522a37":"5fd9ced3","chunk-2d0e97b4":"438609f5","chunk-08cd81d2":"47c4cb16","chunk-19bb65c3":"e9bce0f2","chunk-39e8863c":"a304d6fc","chunk-46653394":"f5ee8af4","chunk-6ef01074":"87343230","chunk-75b63333":"025de07f","chunk-55e66af9":"4dd8fefa","chunk-2d2245c1":"85fa2375","chunk-10284db3":"729cc456","matchInfo":"de858554","chunk-2fa5dd4e":"a7dce3e9","chunk-50b5adf2":"bb64b688","chunk-5a44b69a":"ba3b2b22","chunk-6195b40e":"18b15a97","chunk-639be678":"da787d6f","chunk-9c145f36":"0f1b54fa","chunk-76c227bd":"47e82952","chunk-ddfd021a":"c0f4ff70","groupstageList":"602c4c16","matchFeed":"06a31906","playOff":"5112c3bb","tournamentBrackets":"1854b9c8","tournamentInfo":"71fd290c","tournamentMatches":"dc784271","tournamentNews":"5f799142","tournamentPage":"18a97933","tournamentRules":"65f73d10","tournamentStatistics":"8c3c34d9","tournamentTeams":"44f14195","tournamentVideos":"f5c09f20","tournamentWinners":"dc4113f7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0765dc10":1,"chunk-116fcee8":1,"chunk-13522a37":1,"chunk-08cd81d2":1,"chunk-39e8863c":1,"chunk-6ef01074":1,"chunk-75b63333":1,"chunk-55e66af9":1,"chunk-10284db3":1,"matchInfo":1,"chunk-50b5adf2":1,"chunk-6195b40e":1,"chunk-639be678":1,"chunk-9c145f36":1,"chunk-ddfd021a":1,"groupstageList":1,"playOff":1,"tournamentBrackets":1,"tournamentInfo":1,"tournamentMatches":1,"tournamentPage":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"matchInfo":"matchInfo","groupstageList":"groupstageList","matchFeed":"matchFeed","playOff":"playOff","tournamentBrackets":"tournamentBrackets","tournamentInfo":"tournamentInfo","tournamentMatches":"tournamentMatches","tournamentNews":"tournamentNews","tournamentPage":"tournamentPage","tournamentRules":"tournamentRules","tournamentStatistics":"tournamentStatistics","tournamentTeams":"tournamentTeams","tournamentVideos":"tournamentVideos","tournamentWinners":"tournamentWinners"}[chunkId]||chunkId) + "." + {"chunk-0765dc10":"febbac3d","chunk-116fcee8":"76a97400","chunk-13522a37":"763cd816","chunk-2d0e97b4":"31d6cfe0","chunk-08cd81d2":"1742062f","chunk-19bb65c3":"31d6cfe0","chunk-39e8863c":"6788d268","chunk-46653394":"31d6cfe0","chunk-6ef01074":"a383854b","chunk-75b63333":"1cdb2278","chunk-55e66af9":"c62ef672","chunk-2d2245c1":"31d6cfe0","chunk-10284db3":"81fc9559","matchInfo":"a198afc1","chunk-2fa5dd4e":"31d6cfe0","chunk-50b5adf2":"24ae7b62","chunk-5a44b69a":"31d6cfe0","chunk-6195b40e":"5b4d6283","chunk-639be678":"2e98d360","chunk-9c145f36":"20deaf44","chunk-76c227bd":"31d6cfe0","chunk-ddfd021a":"114cbbc0","groupstageList":"e0482855","matchFeed":"31d6cfe0","playOff":"e37d0d6c","tournamentBrackets":"98ba80f9","tournamentInfo":"1cdb2278","tournamentMatches":"2615e1da","tournamentNews":"31d6cfe0","tournamentPage":"f436e38a","tournamentRules":"31d6cfe0","tournamentStatistics":"31d6cfe0","tournamentTeams":"31d6cfe0","tournamentVideos":"31d6cfe0","tournamentWinners":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
